import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getUserInformation, refreshTheToken, verifyPayment} from "../../lib/services/drive";
import Toasty from "../../theme/components/Toasty";
import {Alert, Box, Button, Container, GlobalStyles, Stack, styled, Typography} from "@mui/material";
import LoadingSpinner from "../../components/loading/loadingSpinner";
import {CheckCircleRounded, ErrorRounded} from "@mui/icons-material";
import {useUser} from "../../lib/hooks";
import LoginModal from "../../components/common/loginModal";
import axios from "axios";
import Cookies from "js-cookie";
import {removeRefreshToken, removeToken, removeUserData, setRefreshToken, setToken, setUserData} from "../../lib/services/jwtService";

export default function Verify() {

    const user = useUser();

    const [loading, setLoading] = useState(5464);
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState([]);

    const [loggedIn, setLoggedIn] = useState(false);
    const [loginModalOpen, setLoginModalOpen] = useState(false);

    const [searchParams] = useSearchParams();
    const authority = searchParams.get('Authority');
    const status = searchParams.get('Status');

    const navigate = useNavigate()

    async function handleVerify(authority, status) {
   /*     if (!user && !loggedIn) {
            setErrors(['برای ادامه ابتدا باید لاگین کنید']);
            return setLoading(false);
        } */
        if (!authority || !status) return;
        try {
            const {data} = await verifyPayment(authority, status);
            if (data?.isSuccess) {
                try {
                    const refreshToken = Cookies.get('refresh-token');
                    const accessToken = Cookies.get('access-token');
                    const {data: refreshData} = await refreshTheToken(accessToken, refreshToken);
                    const {data: newUserData} = await getUserInformation();
                    console.log(newUserData);
                    if (refreshData?.isSuccess && newUserData?.isSuccess) {
                        console.log("success");
                        axios.defaults.headers.common["Authorization"] = "Bearer " + refreshData.value?.access_Token;
                        setToken(refreshData.value?.access_Token);
                        setRefreshToken(refreshData.value?.refresh_Token);
                        setUserData(JSON.stringify(newUserData.value));
                        setSuccess(true);
                    } else {
                        Toasty.error('اعتبار سنجی دچار خطا شد، لطفا مجدد لاگین کنید');
                        removeToken();
                        removeRefreshToken();
                        removeUserData();
                        axios.defaults.headers.common["Authorization"] = undefined;
                        await new Promise((resolve) => setTimeout(resolve, 2000));
                        navigate('/logout');
                    }
                } catch (err) {
                    console.log(err);
                    Toasty.error('خطایی غیر منتظره رخ داد');
                }
            } else {
                if (data?.errors?.length) {
                    setErrors(data.errors);
                }
            }
        } catch (err) {
            console.log(err);
            Toasty.error('خطایی غیر منتظره رخ داد')
        }
        setLoading(false);
    }
    useEffect(() => {
        if (authority) {
            handleVerify(authority, status);
        } else {
            navigate('/404');
        }
    }, [authority, status, loggedIn]);

    return (
        <>
            <GlobalStyles styles={`body, html, main, #root {width: 100%;height: 100%;margin: 0;}`}/>
            <Box width={1} height={1}>
                <Container sx={{ height: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Wrapper>
                        {!loading
                            ?
                            success
                                ?
                                <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                                    <CheckCircleRounded color='success' sx={{ fontSize: {xs: "3rem", lg: "3.5rem"} }}/>
                                    <Typography mt={1} fontSize="1.25rem" fontWeight={600}>عملیات شما با موفقیت انجام شد!</Typography>
                                    <Link to="/drive" style={{ width: "100%" }}>
                                        <Button component="div" fullWidth variant="outlined" color="success" sx={{ mt: 3, py:  1.5,px: {lg: 12} }} disableElevation>بازگشت</Button>
                                    </Link>
                                </Box>
                                :
                                errors?.length
                                    ?
                                    <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column">
                                        <ErrorRounded color='error' sx={{ fontSize: {xs: "3rem", lg: "3.5rem"} }}/>
                                        <Stack mt={1} width={1} spacing={1.5}>
                                            {errors.map((err, ind) => (
                                                <Alert severity="error" key={ind} sx={{ width: 1 }}>{err}</Alert>
                                            ))}
                                        </Stack>
                                        <Stack mt={3} spacing={1.5}>
                                            {!user && (
                                                <Button onClick={() => setLoginModalOpen(true)} fullWidth variant="contained" sx={{ py:  1.5,px: {lg: 12} }} disableElevation>
                                                    ورود به حساب
                                                </Button>
                                            )}
                                            <Link to="/drive" style={{ width: "100%" }}>
                                                <Button component="div" fullWidth variant="outlined" color="success" sx={{ mt: 3, py:  1.5,px: {lg: 12} }} disableElevation>بازگشت</Button>
                                            </Link>
                                        </Stack>
                                    </Box>
                                    : null
                            :
                            <Box width={1} display="flex" alignItems="center" justifyContent="center">
                                <Typography mr={1} fontSize="1.125rem" textAlign="center">در حال پردازش...</Typography>
                                <LoadingSpinner/>
                            </Box>
                        }
                    </Wrapper>
                </Container>
            </Box>

            <LoginModal
            open={loginModalOpen}
            onClose={() => setLoginModalOpen(false)}
            options={{ noReload: true, onSuccess: () =>  setLoggedIn(true)}}/>
        </>
    )
}

const Wrapper = styled(Box)(({theme}) => ({
    width: "100%",
    minWidth: "25vw",
    display: "inline-flex",
    flexWrap: "wrap",
    padding: 24,
    color: "#424242 ",
    background: theme.palette.background.paper,
    border: "1px solid #d1d1d1",
    borderRadius: 16,
    boxShadow: theme.shadows[25],
    [theme.breakpoints.up('lg')]: {
        width: "auto",
        padding: 64,
    },
}))
